import LocalMediaStream from './LocalMediaStream';
import LoggerWrapper from '../../modules/logger-wrapper';
import SafeAudioTrack from './SafeAudioTrack';
import SafeAudioTrackWithBackup from './SafeAudioTrackWithBackup';

const logger = new LoggerWrapper('MEDIA_CORE', 'SafeMediaStream', LoggerWrapper.DEBUG);
logger.setRemoteVerbosity(LoggerWrapper.DEBUG);

class SafeMediaStream extends LocalMediaStream {
	initialize(mediaStream = null) {
		logger.debug('Creating SafeMediaStream', { mediaStream });
		this.initializing = { resolve: () => {}, reject: () => {} };
		if (mediaStream) {
			this.building = new Promise((resolve, reject) => {
				this.initializing.resolve = resolve;
				this.initializing.reject = reject;
			});
			this._originalId = mediaStream.id;
			this.hasAudio = false;
			this.hasVideo = false;
			this.audioTrack = null;
			this.videoTrack = null;
			this._originalMediaStream = mediaStream;
			this._safeMediaStream = null;
			this.initMediaStream();
			this._detect();
			this._addListeners();
		} else {
			throw new Error({
				name: 'MediaStreamNull',
				message: "MediaStream can't be null.",
			});
		}
	}

	async initMediaStream() {
		this._safeMediaStream = new MediaStream();
		this.id = this._safeMediaStream.id;

		const audioTracks = this._originalMediaStream.getAudioTracks();
		const videoTracks = this._originalMediaStream.getVideoTracks();

		if (audioTracks.length > 0) {
			const safeAudioTrack = new SafeAudioTrackWithBackup(audioTracks[0]);
			await safeAudioTrack.boot();
			this.safeAudioTrack = safeAudioTrack;
			this._safeMediaStream.addTrack(safeAudioTrack.track);
			this.safeAudioTrack.on('audio:suspended', () => {
				this.emit('audio:suspended');
			});
			this.safeAudioTrack.on('audio:raw', (e) => {
				this.emit('audio:raw', e);
			});
		}

		if (videoTracks.length > 0) {
			this._safeMediaStream.addTrack(videoTracks[0]);
		}

		//solve the building promise.
		this.initializing.resolve();
	}

	stop() {
		super.stop();
		if (this.safeVideoTrack) {
			this.safeVideoTrack.stop();
		}
		if (this.safeAudioTrack) {
			this.safeAudioTrack.removeAllListeners();
			this.safeAudioTrack.stop();
		}
	}

	_terminateVideoTrack() {
		const tmpTrack = this.videoTrack;
		super._terminateVideoTrack();
		if (this.safeVideoTrack) {
			this.safeVideoTrack.stop();
			this._safeMediaStream.removeTrack(this.safeVideoTrack);
		} else {
			this._safeMediaStream.removeTrack(tmpTrack);
		}
	}

	_terminateAudioTrack() {
		const tmpTrack = this.audioTrack;
		super._terminateAudioTrack();
		if (this.safeAudioTrack) {
			this.safeAudioTrack.stop();
			this._safeMediaStream.removeTrack(this.safeAudioTrack.track);
		} else {
			this._safeMediaStream.removeTrack(tmpTrack);
		}
	}

	get mediaStream() {
		return this._safeMediaStream;
	}
}

export default SafeMediaStream;
